import type { RefAttributes } from "react";
import type { PaymentPeriod, Quote } from "../../../../types";
import { PaymentInformation as Control } from "./PaymentInformation";
import { PaymentInformation as Treatment } from "./ExperimentCancelAnytime/PaymentInformation";
import { useExperiment } from "../../../../../../hooks/experiments";

export type PaymentInformationProps = {
  quote: Quote;
  paymentPeriod?: PaymentPeriod;
};

export const PaymentInformation = ({
  ref,
  ...props
}: PaymentInformationProps & RefAttributes<HTMLDivElement>) => {
  const isCancelAnytime =
    useExperiment("us2602QcpCancelAnytime") === "treatment";

  if (isCancelAnytime) {
    return <Treatment {...props} ref={ref} />;
  }
  return <Control {...props} ref={ref} />;
};

PaymentInformation.displayName = "PaymentInformation";
